export enum DirectSalesSpreadsheetType {
  Farmer
}
